import { Popover } from '@lightspeed/design-system-react'
import React from 'react'
import { ApiTaxRate } from '@vend/types/tax'

import { useT } from '@transifex/react'
import { useSaleManager } from '../../../ng-compat/hooks'
import { useDisplayTax } from './useDisplayTax'
import { DisplayTax } from './DisplayTax'

type Props = {
  closePopover: () => void
}

export const SaleTaxBreakdownPopover = (props: Props) => {
  const { closePopover } = props
  const saleManager = useSaleManager()
  const displayTaxes = useDisplayTax()
  const t = useT()
  const removeTax = (taxRate: ApiTaxRate, taxId: string) =>
    saleManager.removeTax(taxRate, taxId)
  const removeAllTax = (taxGroupId: string) =>
    saleManager.removeAllTax(taxGroupId)

  return (
    <Popover onClose={closePopover} className="sale-popover">
      <h1 className="vd-text-label">
        {t('Remove tax', { _context: 'Heading' })}
      </h1>
      <hr className="vd-hr vd-mb0" />
      <table className="tax-group-table">
        <tbody>
          {displayTaxes.map(tax => {
            return (
              <DisplayTax
                tax={tax}
                removeTax={removeTax}
                key={tax.id}
                removeAllTax={removeAllTax}
              />
            )
          })}
        </tbody>
      </table>
    </Popover>
  )
}
